import { Injectable } from '@angular/core';
import { PatientDocumentDto } from '../dtos/patient-document.dto';
import { PatientDocument } from '../../domain/models/patient-document.model';

@Injectable()
export class PatientDocumentMapper {
  public toPatientDocument(dto: PatientDocumentDto): PatientDocument {
    return {
      id: dto.Id,
      organizationId: dto.OrganizationId,
      departmentId: dto.DepartmentId,
      patientId: dto.PatientId,
      uploadedByUserId: dto.UploadedByUserId,
      fileName: dto.FileName,
      contentType: dto.ContentType,
      sizeBytes: dto.SizeBytes,
      createdAtUtc: dto.CreatedAtUtc,
    };
  }
}
